import { createStore } from "vuex";

import auth from "./modules/auth";
import info from "./modules/info";
import invest from "./modules/invest";
import user from "./modules/user";
import liquidity from "./modules/liquidity";
import map from "./modules/map";

// Create store
export default createStore({
  modules: {
    auth,
    info,
    invest,
    user,
    liquidity,
    map,
  },
});
